var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-home"},[_c('keep-alive',[_c('div',[_c('Banner'),_c('GameTypeGrid',{attrs:{"options":{ data: _vm.gameType }}}),_c('PopularGames'),_c('DeveloperSelectionLazy'),_c('GameListLazy',{attrs:{"title":"各类型游戏","options":{ data: _vm.gameType }}}),_c('FootInfo')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }